import { styled, theme } from "@theme/stitches.config"

export const Input = styled("input", {
    width: "100%",
    p: 12,
    border: `2px solid ${theme.colors.R500}`,
    borderRadius: 4,
    transition: "all 100ms ease",
    backgroundColor: "transparent",
    color: "rgba(255, 255, 255, 0.8)",
    fontSize: theme.fontSizes.mobileBody,
    outline: "none",
    "&[disabled]": {
        cursor: "not-allowed"
    },
    "@mdUp": {
        fontSize: theme.fontSizes.desktopBody
    },
    variants: {
        hasIconLeft: {
            true: {
                pl: 35
            }
        },
        hasIconRight: {
            true: {
                pr: 35
            }
        },
        hasError: {
            true: {
                borderColor: theme.colors.Y100,
                "&:hover, &:focus": {
                    borderColor: theme.colors.Y300
                }
            }
        },
        hasLabel: {
            true: {
                mt: 0
            }
        }
    }
})
